import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Customer } from 'src/app/options/customer.model';
import { Globle } from 'src/assets/globle';
import { OptionService } from '../option.service';


@Component({
  selector: 'app-mandoobs-ballance',
  templateUrl: './mandoobs-ballance.component.html',
  styleUrls: ['./mandoobs-ballance.component.css']
})
export class MandoobsBallanceComponent implements OnInit {

  customers: Customer[] = [];
  displayedColumns: string[] = ['name', 'mobile', 'email', 'balance', "newbalance", "edit"];
  dataSource!: MatTableDataSource<Customer>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  customer: Customer = {} as Customer;
  Catgstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  userLoginId!: string;
  ballance: number = 0;
  pageSize = 100;

  constructor(private service: OptionService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private localStorage: LocalStorageService) {

  }

  ngOnInit() {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.pageSize = this.globle.pageSize;
    this.getCustomers();
  }

  getCustomers() {
    this.spinnerOverlay = true;
    this.service.getAllMandoobs().subscribe(data => {
      this.customers = data;
      this.dataSource = new MatTableDataSource(this.customers);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onDelete(id: string) {
    this.customer.id = id;
    this.openDialog();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  back() {

  }

  update(userData: any) {
    let obj = {
      userLoginId: this.userLoginId,
      userId: userData.id,
      balance: userData.newBallance,
      dept: userData.dept,
      usercategoryId: 1
    }
    this.spinnerOverlay = true;
    this.service.updateUserBalance(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');

      this.spinnerOverlay = false;

      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }


}
